/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Builder_Icon_Calendar_ClockInputs */



/**
* | output |
* | --- |
* | "Calendar" |
*
* @param {Agent_Builder_Icon_Calendar_ClockInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_builder_icon_calendar_clock = /** @type {((inputs?: Agent_Builder_Icon_Calendar_ClockInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Builder_Icon_Calendar_ClockInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kalender")
	return /** @type {LocalizedString} */ ("Calendar")
});